export const stripHtmlTags = (string?: string | null) => {
  if (!string) return string

  return string.replace(/(<([^>]+)>)/gi, '')
}
